import Icon from '@/common/components/Icon';
import Table from '@/common/components/Table';
import { formatDate } from '@/common/functions/dateFormater';
import { useState } from 'react';
import { Section, SectionHeader, TableWrapper } from '../../SerpMonitoringReport.styles';
import { Colors } from '@/common/colors/colors';

const HEADERS = ['Market', 'Keyword', 'Blacklist word', 'Link', 'Date'];

const SerpMonitoringAlertsTable = ({ alertResults = [] }) => {
	const [isOpen, setIsOpen] = useState(true);

	const raws = alertResults.map((alertResult) => (
		<tr key={`${alertResult.key_word}-${alertResult.link}-${alertResult.date}`}>
			<td>{alertResult.market}</td>
			<td>{alertResult.key_word}</td>
			<td>{alertResult.blacklist_word}</td>
			<td>
				<a href={alertResult.link} target='_blank' rel='noreferrer'>
					{alertResult.link}
				</a>
			</td>
			<td>{formatDate(alertResult.date, 'YYYY-MM-DD')}</td>
		</tr>
	));

	return (
		<Section>
			<SectionHeader type='button' onClick={() => setIsOpen((current) => !current)}>
				Alerts
				<Icon name={isOpen ? 'chevron-down' : 'chevron-up'} color={Colors.darkBlue} />
			</SectionHeader>
			{isOpen && (
				<TableWrapper>
					<Table className='styled-table' headers={HEADERS} raws={raws} />
				</TableWrapper>
			)}
		</Section>
	);
};

export default SerpMonitoringAlertsTable;
